export enum SessionViews {
	OVERVIEW = 'overview',
	COMPONENTS = 'components',
	ALL_ISSUES = 'all-issues'
}
